<script lang="ts">
import { defineComponent, ref, provide } from 'vue';
import VueForm from './../vueForm.vue';
import {validator}    from '@js/form_validators';

import { FormSchema, schemaFunc } from './../js/form_schema';
import { modelObject, modelFunc } from './../js/form_model';

export default defineComponent ({
    name: 'FormIndex',
    components: {
        'testForm': VueForm,
        // 'testForm': testFormBox
    },
    setup() {
        const model = ref<modelObject>(modelFunc());
        const schema = ref<FormSchema>(schemaFunc());
        const showModel = ref(true);
        const validators = ref(validator());
        const formBox = ref<{ 
            validateAll: () => boolean,
            validateIt: (
                fromChild: {
                    id: number,
                    model:string,
                    validator: object,
                    vText: string
                }) => boolean
        }>({ 
            validateAll: () => true,
            validateIt: () => true
        });

        function openFunc(newVal:{functionVal:string, argumentsVal:any}) {
            console.log("openFunc", newVal);
        }

        function checkModel() {
            if (formBox !== null && formBox.value !== null && typeof formBox.value.validateAll === 'function') {
                const checkValues = formBox.value.validateAll();

                console.log("checkModel", checkValues, model.value);
            }
        }

        return {
            formBox,
            model, 
            openFunc,
            schema, 
            showModel,
            validators, 
            checkModel,
        }
    }
});
</script>
<template lang="pug">
div
    testForm(
        :model="model"
        :schema="schema"
        :showModel="showModel"
        :formBox="formBox"
        :validators="validators"
        redAst = "red"
        labelRed = "red"
        formSmallSize = "9" 
        hintFontSize= "9"
        hintColor= "grey" 
        hintFontStyle =  "normal"
        @openFunc="openFunc"
        ref="formBox"
    )
    br
    br
    .btn-toolbar.justify-content-between(rowl="toolbar")
        .btn-group(role="group")
            button.btn.btn-primary(type="button" @click="checkModel()") speichern
</template>
<style lang="scss">
@import './../css/bootstrap.scss';
@import './../css/index.scss';
$namespace : 'xmx';
$default-color: black;
$primary-color: orange;
$input-border-radius: 0px;
$today-color: orange;
@import '~vue-datepicker-next/scss/index.scss';
</style>